
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aplikacje-bluetooth",
      function () {
        return require("private-next-pages/aplikacje-bluetooth.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aplikacje-bluetooth"])
      });
    }
  